import React, { useEffect, useState, useContext, useCallback } from "react";
import ReactPlayer from "react-player";
import AuthService from "./auth/AuthService";
import { useLocation } from "react-router-dom";
import thum from "../../src/images/thum.jpg";
// import thum1 from "../../src/images/thum1.jpg";
import thum2 from "../../src/images/thum2.jpg";
import thum3 from "../../src/images/thum3.jpg";
import thum4 from "../../src/images/thum4.jpg";
import thum5 from "../../src/images/thum5.jpg";

import {
  Grid,
  Button,
  Typography,
  Box,
  Fade,
  LinearProgress,
  Container,
  Divider,
  Tabs,
  Tab,
  // colors,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Assessment, VideoLibrary, School } from "@material-ui/icons";
import { sasLink } from "./common/lib/sync/videoSyncLib";
import WebQuestion from "./common/WebQuestion";
import config from "../config";
import ThingsContext from "./PublicLayout/thingsContext";
// import { set } from "lodash";

const Auth = new AuthService();

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "16px",
    width: "100%",
    background: "#ffffff",
    minHeight: "100vh",
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(3),
    },
  },
  container: {
    maxWidth: "1380px",
    margin: "0 auto",
    padding: "0 8px",
    [theme.breakpoints.up("sm")]: {
      padding: "0 16px",
    },
  },
  headerCard: {
    background: "transparent",
    boxShadow: "none",
    border: "none",
    overflow: "hidden",
    position: "relative",
  },
  headerContent: {
    padding: theme.spacing(2, 0),
    textAlign: "center",
  },
  studioButton: {
    background: "#3871C1",
    color: "white",
    borderRadius: "20px",
    padding: theme.spacing(1, 3),
    fontWeight: "600",
    marginBottom: theme.spacing(2.2),
    boxShadow: "none",
    fontSize: "12px",
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(1, 5),
      fontSize: "1rem",
    },
    "&:hover": {
      background: "#0830A0",
      boxShadow: "none",
    },
  },
  title: {
    fontWeight: 700,
    fontSize: "1.5rem",
    marginBottom: theme.spacing(1),
    color: "#333",
    [theme.breakpoints.up("sm")]: {
      fontSize: "2.2rem",
    },
  },
  dateChip: {
    background: "#666666",
    color: "white",
    fontWeight: 600,
    fontSize: "0.875rem",
    padding: theme.spacing(1, 2),
  },
  mediaCard: {
    background: "transparent",
    boxShadow: "none",
    border: "none",
    borderRadius: "0",
    marginBottom: theme.spacing(2),
    overflow: "hidden",
    transition: "none",
  },
  assessmentCard: {
    background: "#f9e7b3",
    color: "#333333",
    borderRadius: "15px",
    padding: theme.spacing(3),
    textAlign: "center",
    marginBottom: theme.spacing(3),
    boxShadow: "none",
    border: "none",
  },
  assessmentTitle: {
    fontWeight: 700,
    fontSize: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
  },
  videoContainer: {
    position: "relative",
    paddingTop: "56.25%",
    overflow: "hidden",
    marginBottom: theme.spacing(2),
    borderRadius: "20px",
    [theme.breakpoints.up("sm")]: {
      height: "810px",
      padding: "0 16px",
    },
  },
  reactPlayer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: "1px solid #e0e0e0", // Added top border here
  },
  videoInfo: {
    padding: theme.spacing(2, 0),
    backgroundColor: "transparent",
  },
  videoTitle: {
    fontWeight: "600",
    marginBottom: theme.spacing(1),
    fontSize: "1.1rem",
    colors: "#343A40",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.725rem",
      colors: "#343A40",
    },
  },
  videoSubtitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    gap: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      gap: 0,
    },
  },
  tabsContainer: {
    background: "transparent",
    overflow: "hidden",
    boxShadow: "none",
    border: "none",
    borderTop: "1px solid #e0e0e0", // Added top border here
  },
  tabs: {
    "& .MuiTab-root": {
      fontWeight: "bold",
      fontSize: "0.9rem",
      textTransform: "none",
      color: "#333333",
      minHeight: "auto",
      padding: theme.spacing(1, 1),
      [theme.breakpoints.up("sm")]: {
        fontSize: "1rem",
        padding: theme.spacing(1, 2),
      },
    },
    "& .Mui-selected": {
      color: "#333333",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
    "& .MuiTabs-flexContainer": {
      borderBottom: "none",
    },
  },
  tabPanel: {
    padding: theme.spacing(2, 0),
  },
  videoGridCard: {
    background: "transparent",
    boxShadow: "none",
    border: "none",
    borderRadius: "8px",
    height: "100%",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    },
  },
  videoThumbnail: {
    height: "100px",
    borderRadius: "8px",
    [theme.breakpoints.up("sm")]: {
      height: "120px",
    },
    [theme.breakpoints.up("md")]: {
      height: "118px",
      width: "210px",
    },
  },
  videoCardContent: {
    background: "transparent",
    padding: theme.spacing(1, 0),
    "&:last-child": {
      paddingBottom: theme.spacing(1),
    },
  },
  videoCardTitle: {
    fontWeight: "bold",
    margin: theme.spacing(1, 0),
    marginBottom: theme.spacing(0.5),
    fontSize: "1rem",
    lineHeight: "1.2",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
  controlsSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(3),
  },
  nextButton: {
    background: "#2e4f46",
    color: "white",
    borderRadius: "50px",
    marginBottom: "20px",
    fontSize: "1.1rem",
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "none",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "#f4d03f",
      transform: "translateY(-2px)",
      boxShadow: "none",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    minHeight: "200px",
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(6),
      minHeight: "280px",
    },
  },
  loadingText: {
    marginTop: theme.spacing(2),
    color: "#666666",
    fontWeight: 500,
    fontSize: "0.9rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
  progressBar: {
    width: "150px",
    height: "6px",
    borderRadius: "3px",
    background: "#666666",
    [theme.breakpoints.up("sm")]: {
      width: "200px",
    },
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: "#333333",
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(6),
    },
  },
  emptyStateIcon: {
    fontSize: "3rem",
    color: "#e0e0e0",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      fontSize: "4rem",
    },
  },
  // Updated styles for responsive single row layout
  // singleRowContainer: {
  //   display: "flex",
  //   gap: theme.spacing(1.5),
  //   overflowX: "auto",
  //   overflowY: "hidden",
  //   paddingBottom: theme.spacing(1),
  //   paddingRight: theme.spacing(1),
  //   // Better mobile scrolling
  //   "-webkit-overflow-scrolling": "touch",
  //   scrollBehavior: "smooth",
  //   "&::-webkit-scrollbar": {
  //     height: "6px",
  //   },
  //   "&::-webkit-scrollbar-track": {
  //     background: "transparent",
  //   },
  //   "&::-webkit-scrollbar-thumb": {
  //     background: "#e0e0e0",
  //     borderRadius: "3px",
  //   },
  //   [theme.breakpoints.up("sm")]: {
  //     gap: theme.spacing(2),
  //   },
  // },
  singleRowContainer: {
    display: "flex",
    flexWrap: "wrap", // important!
    gap: theme.spacing(2),
    justifyContent: "space-between", // nicely space 6
  },
  singleRowCard: {
    flex: "0 0 calc(15.66% - 12px)", // 100% ÷ 6
    boxShadow: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    },
    [theme.breakpoints.down("md")]: {
      flex: "0 0 calc(33.33% - 12px)", // 3 per row on medium
    },
    [theme.breakpoints.down("sm")]: {
      flex: "0 0 calc(50% - 12px)", // 2 per row on small
    },
    [theme.breakpoints.down("xs")]: {
      flex: "0 0 100%", // full on tiny
    },
  },

  // singleRowCard: {
  //   background: "transparent",
  //   boxShadow: "none",
  //   border: "none",
  //   borderRadius: "8px",
  //   // Responsive widths - much wider now
  //   minWidth: "240px",
  //   maxWidth: "240px",
  //   flexShrink: 0, // Prevent shrinking
  //   cursor: "pointer",
  //   transition: "all 0.3s ease",
  //   [theme.breakpoints.up("sm")]: {
  //     minWidth: "280px",
  //     maxWidth: "280px",
  //   },
  //   [theme.breakpoints.up("md")]: {
  //     minWidth: "320px",
  //     maxWidth: "320px",
  //   },
  //   [theme.breakpoints.up("lg")]: {
  //     minWidth: "350px",
  //     maxWidth: "350px",
  //   },
  //   "&:hover": {
  //     transform: "translateY(-2px)",
  //     boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  //   },
  // },
  currentVideoIndicator: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    background: "#093FB4",
    color: "white",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    zIndex: 1,
  },
}));

// Tab Panel Component
function TabPanel(props) {
  const { children, value, index, classes, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box className={classes.tabPanel}>{children}</Box>}
    </div>
  );
}

export default function PublicMedia() {
  const location = useLocation();
  const ref = React.useRef(null);
  const [myVideo, setMyVideo] = useState("");
  const [currentVideoTitle, setCurrentVideoTitle] = useState("VIDEO TITLE");
  const [currentVideoSubtitle, setCurrentVideoSubtitle] = useState("SUBTITLE");
  const [currentVideoDate, setCurrentVideoDate] = useState("4 Week Ago");
  const [assessment, setAssessment] = useState("");
  const [assessment_id, setAssessmentId] = useState(0);
  const [seek, setSeek] = useState(0);
  const [loading, setLoading] = useState(false);
  const [things, setThings] = useContext(ThingsContext);
  const [question_count, setQuestionCount] = useState(0);
  const [tabValue, setTabValue] = useState(0);
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  const classes = useStyles();

  // Updated video data with YouTube demo links and exactly 6 videos for Basics
  const videoData = {
    basics: [
      {
        id: 1,
        title: "Wheel Alignment",
        duration: "1 week ago",
        thumbnail: thum3,
        url: "https://www.youtube.com/watch?v=7d2K_mKgsZ0",
        subtitle: "Wheel Alignment",
      },
      {
        id: 2,
        title: "Car Wash",
        duration: "2 weeks ago",
        thumbnail: thum4,
        url: "https://www.youtube.com/watch?v=S1Bm1414u_w",
        subtitle: "Vehicle Services",
      },
      {
        id: 3,
        title: "Testing Enginess",
        duration: "3 weeks ago",
        thumbnail: thum2,
        url: "https://www.youtube.com/watch?v=zc6TsxFDfdg",
        subtitle: "Vehicle Services",
      },
      {
        id: 4,
        title: "Oil Changes",
        duration: "4 weeks ago",
        thumbnail: thum,
        url: "https://www.youtube.com/watch?v=VtB0xAe51Bs",
        subtitle: "Vehicle Services",
      },
      {
        id: 5,
        title: "Car Alignment Assesess",
        duration: "1 month ago",
        thumbnail: thum4,
        url: "https://www.youtube.com/watch?v=XEmG4nwnmNs",
        subtitle: "Vehicle Services",
      },
      {
        id: 6,
        title: "Express.js Crash Course",
        duration: "1 month ago",
        thumbnail: "https://img.youtube.com/vi/L72fhGm1tfE/maxresdefault.jpg",
        url: thum5,
        subtitle: "Web framework tutorial",
      },
    ],
  };

  const getQueryParams = (query) => {
    return new URLSearchParams(query);
  };

  const [selection] = useState(() => {
    const queryParams = getQueryParams(location.search);
    const data = queryParams.get("data");
    console.log("data", data);
    if (!data) return [];
    const arr = data.split(",");
    return arr;
  });

  useEffect(() => {
    if (selection.length > 0) {
      setThings(selection);
    }
  }, [selection, setThings]);

  const [videoId, setVideoId] = useState(0);

  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  };

  const playVideo = (name) => {
    setMyVideo(name);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // New function to handle video card clicks
  const handleVideoClick = (video) => {
    setSelectedVideoId(video.id);
    setCurrentVideoTitle(video.title);
    setCurrentVideoSubtitle(video.subtitle);
    setCurrentVideoDate(video.duration);
    playVideo(video.url);
    setSeek(0);
  };

  const saveVideo = (duration) => {
    Auth.post("saveVideoLogP", {
      video_id: videoId,
      school_id: things[0],
      attendance_ids: things[4],
      duration: duration,
      log_device: 1,
    })
      .then((res) => {
        console.log("saveVideoLog", res);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const updateVideoLogs = (seek, end) => {
    console.log("attendanceIds", things[4]);
    if (!things[4]) {
      return;
    }
    const obj = {
      attendance_ids: things[4],
      seek: Number.parseInt(seek),
      video_id: videoId,
    };
    if (end) {
      obj["done"] = 1;
    }
    console.log("obj", obj);
    Auth.post("updateVideoLogP", obj)
      .then((res) => {
        // console.log("saveVideoLog", res);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const playVideoFunc = useCallback((item) => {
    setLoading(true);
    setAssessment("");
    setVideoId(item.video_id);
    if (
      Number.parseInt(item.downloaded_size) < Number.parseInt(item.total_size)
    ) {
      sasLink(item.video_id)
        .then((data) => {
          playVideo(`${data.link}`);
          setLoading(false);
        })
        .catch((e) => {
          console.log("e", e);
          setLoading(false);
        });
    } else {
      playVideo(`${config.videoEndPoint}${item.video_id}`);
      setLoading(false);
    }
    setSeek(Number.parseInt(item.seek ? item.seek : 0));
  }, []);

  const process = useCallback(() => {
    setLoading(true);
    Auth.post("getRunningVideo", {
      school_id: selection[0],
      grade_id: selection[1],
      section_id: selection[2],
      subject_id: selection[3],
      student_id: selection[5],
      first: true,
      start_date: formatDate(new Date()),
    })
      .then((res) => {
        if (res.status) {
          console.log("#########res.data", res.data);
          const item = res.data[0];
          if (item.status === "2") {
            setAssessment(item.assessment_name);
            setAssessmentId(item.assessment_id);
            setQuestionCount(item.question_count);
            setVideoId(0);
            playVideo("");
            setSeek(0);
          } else {
            const data = res.data[0];
            setCurrentVideoSubtitle(data.subject_name);
            setCurrentVideoTitle(data.topic_name);
            setAssessmentId(0);
            setQuestionCount(0);
            playVideoFunc(item);
          }
        } else {
          setAssessment("");
          setVideoId(0);
          playVideo("");
          setSeek(0);
        }
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, [selection, playVideoFunc, setQuestionCount]);

  useEffect(() => {
    process();
  }, [process]);

  useEffect(() => {
    ref.current && ref.current.seekTo(seek, "seconds");
  }, [seek]);

  useEffect(() => {
    if (things.length === 4 && things[3] !== null) {
      const item = things[3];
      playVideoFunc(item);
    }
  }, [things, playVideoFunc]);

  // Updated render function for single row layout with better mobile support
  const renderVideoRow = (videos) => (
    <Box className={classes.singleRowContainer}>
      {videos.map((video, index) => (
        <div
          key={index}
          className={classes.singleRowCard}
          onClick={() => handleVideoClick(video)}
          style={{
            border:
              selectedVideoId === video.id
                ? "2px solid #093FB4"
                : "1px solid transparent",
          }}
        >
          <Box style={{ position: "relative" }}>
            <img
              className={classes.videoThumbnail}
              src={video.thumbnail || "/placeholder.svg"}
              alt={video.title}
              style={{
                width: "100%",
                display: "block",
                objectFit: "cover",
              }}
            />
            {selectedVideoId === video.id && (
              <Box className={classes.currentVideoIndicator}>▶</Box>
            )}
          </Box>
          <Box className={classes.videoCardContent}>
            <Typography variant="subtitle2" className={classes.videoCardTitle}>
              {video.title}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{
                fontSize: "0.875rem",
                color: "#9A9A9A",
                style: "medium",
              }}
            >
              {video.subtitle}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{
                fontSize: "0.875rem",
                color: "#9A9A9A",
                style: "medium",
              }}
            >
              {video.duration}
            </Typography>
          </Box>
        </div>
      ))}
    </Box>
  );

  return (
    <Box className={classes.root}>
      <Container className={classes.container}>
        <Fade in={true} timeout={800}>
          <div className={classes.headerCard}>
            <div className={classes.headerContent}>
              <Typography variant="h1" className={classes.title}>
                Media Learning Center
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{
                  marginBottom: "20px",
                  fontWeight: "500",
                  fontSize: "1.125rem",
                }}
              >
                Session Date:{" "}
                <span style={{ marginBottom: "18px", color: "#3871C1" }}>
                  {formatDate(new Date())}
                </span>
              </Typography>
            </div>
          </div>
        </Fade>

        {things[0] && things[1] && things[2] ? (
          <Fade in={true} timeout={1000}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                {assessment_id ? (
                  <div className={classes.assessmentCard}>
                    <Typography
                      variant="h4"
                      className={classes.assessmentTitle}
                    >
                      <Assessment />
                      Assessment Time
                    </Typography>
                    <Typography variant="h5" style={{ fontWeight: 500 }}>
                      "{assessment}"
                    </Typography>
                    <Divider style={{ margin: "24px 0" }} />
                    <WebQuestion
                      selection={selection}
                      assessment_id={assessment_id}
                      question_count={question_count}
                    />
                  </div>
                ) : (
                  <>
                    {/* Main Video Player */}
                    <div className={classes.mediaCard}>
                      {loading ? (
                        <Box className={classes.loadingContainer}>
                          <VideoLibrary className={classes.emptyStateIcon} />
                          <LinearProgress className={classes.progressBar} />
                          <Typography
                            variant="body1"
                            className={classes.loadingText}
                          >
                            Loading media content...
                          </Typography>
                        </Box>
                      ) : myVideo ? (
                        <>
                          <Box className={classes.videoContainer}>
                            <ReactPlayer
                              ref={ref}
                              playing={false}
                              className={classes.reactPlayer}
                              url={myVideo}
                              controls={true}
                              width="100%"
                              height="100%"
                              onProgress={(e) => {
                                updateVideoLogs(e.playedSeconds, false);
                              }}
                              onDuration={(e) => {
                                saveVideo(e);
                              }}
                              onEnded={(e) => {
                                updateVideoLogs(0, true);
                              }}
                            />
                          </Box>
                          {/* Video Info */}
                          <Box className={classes.videoInfo}>
                            <Typography
                              variant="h6"
                              className={classes.videoTitle}
                            >
                              {currentVideoTitle}
                            </Typography>
                            <Box className={classes.videoSubtitle}>
                              <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{
                                  color: "##343A40",
                                  fontWeight: "500",
                                  fontSize: "1rem",
                                }}
                              >
                                {currentVideoSubtitle}
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{
                                  color: "#3871C1",
                                  fontWeight: "500",
                                  fontSize: "1rem",
                                }}
                              >
                                {currentVideoDate}
                              </Typography>
                            </Box>
                          </Box>
                        </>
                      ) : (
                        <Box className={classes.emptyState}>
                          <VideoLibrary className={classes.emptyStateIcon} />
                          <Typography
                            variant="h6"
                            style={{ marginBottom: "8px" }}
                          >
                            No Video Available
                          </Typography>
                          <Typography variant="body2">
                            Click on any video below to start watching or
                            there's no video content available for this session
                            at the moment.
                          </Typography>
                        </Box>
                      )}
                      <Fade in={true} timeout={800}>
                        <div className={classes.headerCard}>
                          <div className={classes.headerContent}>
                            <Button
                              onClick={() => {
                                process();
                                const queryParams = getQueryParams(
                                  location.search
                                );
                                const data = queryParams.get("data");
                                const arr = data.split(",");
                                setThings(arr);
                              }}
                              className={classes.studioButton}
                            >
                              TM STUDIO Next Video
                            </Button>
                          </div>
                        </div>
                      </Fade>
                    </div>

                    {/* Tabs Section below 6th videos*/}
                    <div className={classes.tabsContainer}>
                      <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        className={classes.tabs}
                      >
                        <Tab
                          label={
                            <span
                              style={{
                                display: "block",
                                fontSize: "1.26rem",
                                textAlign: "left",
                                marginTop: "1rem",
                                width: "100%",
                                fontWeight: "700",
                              }}
                            >
                              Basics
                            </span>
                          }
                        />
                      </Tabs>
                      <TabPanel value={tabValue} index={0} classes={classes}>
                        {renderVideoRow(videoData.basics)}
                      </TabPanel>
                    </div>
                  </>
                )}
              </Grid>
            </Grid>
          </Fade>
        ) : (
          <Fade in={true} timeout={1000}>
            <div className={classes.mediaCard}>
              <Box className={classes.loadingContainer}>
                <School className={classes.emptyStateIcon} />
                <LinearProgress className={classes.progressBar} />
                <Typography variant="body1" className={classes.loadingText}>
                  Initializing learning session...
                </Typography>
              </Box>
            </div>
          </Fade>
        )}
      </Container>
    </Box>
  );
}
